import { render, staticRenderFns } from "./InstallationDetails.vue?vue&type=template&id=b8b1fb8a&scoped=true&"
import script from "./InstallationDetails.vue?vue&type=script&lang=js&"
export * from "./InstallationDetails.vue?vue&type=script&lang=js&"
import style0 from "./InstallationDetails.vue?vue&type=style&index=0&id=b8b1fb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b1fb8a",
  null
  
)

export default component.exports